import { get } from '@bigyouth/base'

export default {
  name: 'nav-account',
  isMobile: window.innerWidth < 768,

  ui: {
    'navAccountItems[]': '[js-nav-account-item]',
  },

  componentDidMount () {
    this.scrollToItem()
  },

  scrollToItem () {
    const page = this.el.getAttribute('data-page')

    if (this.isMobile) {
      const item = get('li[data-page="' + page + '"]')
      let offset = item.offsetLeft

      if (page === 'infos') {
        offset = offset + (window.getComputedStyle(this.el, null).getPropertyValue('padding-left'))
      }

      if (page === 'addresses') {
        offset = offset - (window.innerWidth / 2) + (item.clientWidth / 2)
      }

      this.el.scrollLeft = offset
    }
  },
}
